export const sliderData = [
  {
    id: 1,
    brandIdentity: "BRAND IDENTITY",
    brandIdentityTextColor: "#9F3333",
    title: "<span class='bold'>Vittaverse</span> Crypto Currency",
    desc: "Vittaverse is fully regulated, licensed & Secured",
    img: "/assets/images/slider-images/Vittaverse.webp",
    flagImg: "/assets/images/slider-images/flags/vittaverse.png",
    projectUrl: "https://vittaverse.com/en/",
    workUrl: "/work/vittaverse"
  },
  {
    id: 2,
    brandIdentity: "Social Network",
    brandIdentityTextColor: "#DC9848",
    title: "<span class='bold'>Mobu - Barber</span> Health & Wellness",
    desc: "Provides the services for the human Health & Wellness.",
    img: "/assets/images/slider-images/Mobu.webp",
    flagImg: "/assets/images/slider-images/flags/mobu.png",
    projectUrl: "https://www.behance.net/gallery/176937185/Mobu-Barber-Social-App",
    workUrl: "/work/mobu"
  },
  {
    id: 3,
    brandIdentity: "iGAMING PLATFORM",
    brandIdentityTextColor: "#1DE9B6",
    title: "<span class='bold'>Upgaming</span> Interaction design",
    desc: "Introducing the first interaction iGaming platfrom - A new discovery experience.",
    img: "/assets/images/slider-images/Upgaming.webp",
    flagImg: "/assets/images/slider-images/flags/upgaming.png",
    projectUrl: "https://upgaming.com/",
    workUrl: "/work/upgaming"
  },
  {
    id: 4,
    brandIdentity: "E - COMMERCE",
    brandIdentityTextColor: "#E3643B",
    title: "<span class='bold'>Nespola</span> Digital Book - Store",
    desc: "Our mission is to make book publishing an accessible place for everyone.",
    img: "/assets/images/slider-images/Nespola.webp",
    flagImg: "/assets/images/slider-images/flags/nespola.png",
    projectUrl: "https://nespola.io/",
    workUrl: "/work/nespola"
  },
  {
    id: 5,
    brandIdentity: "TAXI APP",
    brandIdentityTextColor: "",
    title: "<span class='bold'>Fahrly - GO!</span> Ride Acceptance",
    desc: "comprehensive driver management & advanced fleet analytics.",
    img: "/assets/images/slider-images/Fahrlygo.webp",
    flagImg: "/assets/images/slider-images/flags/fahrly.png",
    projectUrl: "https://apps.apple.com/ge/app/fahrlygo/id1670873916",
    workUrl: "/work/fahrlygo"
  },
  {
    id: 6,
    brandIdentity: "AUTO MOBILE",
    brandIdentityTextColor: "#BD0321",
    title: "<span class='bold'>Hyundai</span>3D Car Modify",
    desc: "Explore Hyundai’s 3D car configurator. Customize a variety of cars with tuning parts",
    img: "/assets/images/slider-images/Hyundai.webp",
    flagImg: "/assets/images/slider-images/flags/hyundai.png",
    projectUrl: "https://www.behance.net/gallery/120429025/UXUI-WEB-DESIGN-HYUNDAI-AUTO-GEORGIA",
    workUrl: "/work/hyundai"
  },
  {
    id: 7,
    brandIdentity: "INSURANCE APP",
    brandIdentityTextColor: "#E0201D",
    title: "<span class='bold'>GBG- Benefits</span> Health-Auto-Travel",
    desc: "Benefits is to offer its customers faster & simplified services.",
    img: "/assets/images/slider-images/Benefits.webp",
    flagImg: "/assets/images/slider-images/flags/benefits.png",
    projectUrl: "https://www.behance.net/gallery/122517705/Benefits-Insurance-Mobile-App-UXUI",
    workUrl: "/work/benefits"
  },
  {
    id: 8,
    brandIdentity: "E - COMMERCE",
    brandIdentityTextColor: "#2D2E2C",
    title: "<span class='bold'>A.Desing</span> Minimalistic Shop",
    desc: "Interface elements includes minimalistic & extraordinay aesthetic design.",
    img: "/assets/images/slider-images/Minial Ecommerce.webp",
    flagImg: "/assets/images/slider-images/flags/a-design.png",
    projectUrl: "https://www.behance.net/gallery/140261723/ADesign-E-Commerce-UXUI-Minimal-Concept",
    workUrl: "/"
  },
  {
    id: 9,
    brandIdentity: "E - COMMERCE",
    brandIdentityTextColor: "#D5C023",
    title: "<span class='bold'>WOOORDS</span> Poster Generator",
    desc: "This platform lets you create awesome digital prints for your little one!",
    img: "/assets/images/slider-images/Wooords.webp",
    flagImg: "/assets/images/slider-images/flags/wooords.png",
    projectUrl: "https://www.behance.net/gallery/146704915/WOOOORD-Poster-Generator-UXUI-Web-App",
    workUrl: "/work/wooords"
  },
];
